import english from "./english";
import french from "./french";

export const globalStrings = {
  en: english,
  fr: french,
};
